export default __webpack_public_path__ + "static/media/Night in the Backstreets.18447dc3.png";